export default __webpack_public_path__ + "static/media/green-circle.5a54c8b4.svg";